import { useContext } from 'react';

import { LanguageContext } from '../../config/LanguageContext';
import stringTable from '../../config/stringTable';

const Text = ({ value }) => {
  const { language } = useContext(LanguageContext);
  if (typeof stringTable[language][value] === 'function') {
    return stringTable[language][value]();
  }
  return stringTable[language][value] || stringTable.en[value] || value;
};

export default Text;

export const getText = (value) => Text({ value });
